/* 🤖 this file was generated by svg-to-ts */
export const mgcIconEaseInRegular: {
  name: 'ease-in-regular';
  data: string;
} = {
  name: 'ease-in-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M19.647 3.065c-.267.098-.454.309-.687.775-.637 1.274-1.806 3.301-2.758 4.78-3.149 4.896-6.301 8.192-9.182 9.599-.922.451-1.857.715-2.703.764-.586.034-.792.098-1.01.316a.96.96 0 0 0-.001 1.401c.292.292.575.343 1.42.258 4.184-.421 8.645-4.244 13.182-11.298 1.284-1.998 3.01-5.092 3.073-5.511a.999.999 0 0 0-.51-1.018c-.241-.125-.587-.153-.824-.066"/></svg>`
};
